import { Product } from '@df/catalog/product/product';
import { NgInject } from '@df/ng/ng-inject';
import take from 'lodash-es/take';
import { ModelCarouselEngine } from '../../catalog/ui/page/component/model-carousel/model-carousel-engine';
import { IModelCarouselLoadRequest } from '../../catalog/ui/page/component/model-carousel/model-carousel.interface';
import { ModelCarouselService } from '../../catalog/ui/page/component/model-carousel/model-carousel.service';
import { NBloomreach } from './bloomreach.namespace';
import { BloomreachService } from './bloomreach.service';

interface IBloomreachRecommendationsModelCarouselLoadRequest extends IModelCarouselLoadRequest {
    // must be `exponeaOptions` to be compatible with old data
    exponeaOptions?: string;
}

export class BloomreachRecommendationsModelCarouselEngine extends ModelCarouselEngine<Product> {
    @NgInject(BloomreachService)
    protected bloomreachService!: BloomreachService;

    get(type: string, data: IBloomreachRecommendationsModelCarouselLoadRequest): Promise<Product[]> {
        return new Promise(resolve => {
            // must be `exponeaOptions` to be compatible with old data
            const options = data?.exponeaOptions;
            
            if (options) {
                this.bloomreachService
                    .loadRecommendationsProducts(options)
                    .then(products => {
                        resolve(data.limit ? take(products, data.limit) : products);
                    })
                    .catch(() => {
                        resolve([]);
                    });
            } else {
                resolve([]);
            }
        });
    }
}

ModelCarouselService.engines[NBloomreach.RECOMMENDATIONS_ENGINE_ID] = new BloomreachRecommendationsModelCarouselEngine();
